module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="soft-review-info soft-review-avail">\n    <aside>\n        ' +
__e( progress.current ) +
'/' +
__e( progress.total ) +
'\n    </aside>\n    <header>\n        <h2>' +
__e( position.title ) +
'</h2>\n        <div class="soft-review-company">\n            ' +
__e( position.company_name ) +
' - ' +
__e( position.location_name ) +
'\n        </div>\n        <div class="soft-review-warning">\n            ' +
((__t = ( $.svgIcon('warning') )) == null ? '' : __t) +
'\n            <span>\n                Non-preferred hours\n            </span>\n        </div>\n    </header>\n    <section class="soft-review-content">\n        <div class="soft-review-type soft-review-meta">\n            <div>You said "' +
__e( mismatch.pref ) +
'"</div>\n            <ul class="pill-list">\n                <li';
 if (mismatch.hasIcon) { ;
__p += ' class="pill-shift-' +
__e( mismatch.shift ) +
'"';
 } ;
__p += '>\n                    ';
 if (mismatch.hasIcon) { ;
__p += '\n                        <div class="soft-review-icon-container">\n                            <span class="shift-icon shift-' +
__e( mismatch.shift ) +
'"></span>\n                        </div>\n                    ';
 } ;
__p += '\n                    <span>' +
__e( _.capitalize(mismatch.shift) ) +
' shifts</span>\n                </li>\n            </ul>\n        </div>\n        <div class="soft-review-meta">\n            <span>The hours for this job are:</span>\n            <div class="soft-review-shift-info">\n                <div>\n                    <span';
 if (highlight === 'start') { ;
__p += ' class="soft-review-meta-highlight"';
 };
__p += '>\n                        ' +
__e( position.schedule_start ) +
',\n                    </span>\n                    <span';
 if (highlight === 'duration') { ;
__p += ' class="soft-review-meta-highlight"';
 };
__p += '>\n                        ' +
__e( position.schedule_duration ) +
',\n                    </span>\n                    <span';
 if (highlight === 'description') { ;
__p += ' class="soft-review-meta-highlight"';
 };
__p += '>\n                        ' +
__e( position.schedule_description ) +
'\n                    </span>\n                </div>\n            </div>\n        </div>\n    </section>\n\n    <footer>\n        <a href="#" class="btn-confirm">Yes, I can work these hours</a>\n        <a href="#" class="btn-cancel">I\'m no longer interested</a>\n    </footer>\n</div>\n';

}
return __p
}